import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api.interface';
import { AdminUser, CreateAdminUserDto, UpdateAdminUserDto } from '../models/admin-user.model';

@Injectable({
  providedIn: 'root'
})
export class AdminAdminUsersService {
  private baseUrl = '/api/admin/admin-users';
  
  constructor(private http: HttpClient) {}
  
  /**
   * Get all admin users
   */
  getAdminUsers(): Observable<ApiResponse<AdminUser[]>> {
    return this.http.get<ApiResponse<AdminUser[]>>(this.baseUrl);
  }
  
  /**
   * Get admin user by ID
   */
  getAdminUserById(id: number): Observable<ApiResponse<AdminUser>> {
    return this.http.get<ApiResponse<AdminUser>>(`${this.baseUrl}/${id}`);
  }
  
  /**
   * Create admin user
   */
  createAdminUser(dto: CreateAdminUserDto): Observable<ApiResponse<AdminUser>> {
    return this.http.post<ApiResponse<AdminUser>>(this.baseUrl, dto);
  }
  
  /**
   * Update admin user
   */
  updateAdminUser(id: number, dto: UpdateAdminUserDto): Observable<ApiResponse<AdminUser>> {
    return this.http.put<ApiResponse<AdminUser>>(`${this.baseUrl}/${id}`, dto);
  }
  
  /**
   * Delete admin user
   */
  deleteAdminUser(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
